import store from "@/store/index";
//获取按钮状态
const getBtnStatus = () => {
  let moduleBgs = localStorage.getItem("uSettings");
  if (moduleBgs) {
    moduleBgs = JSON.parse(moduleBgs);
    return moduleBgs;
  } else {
    return null;
  }
};

// 比例尺监听
const updateScaleChange = () => {
  const viewDocCoord = rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();
  const { pt1, pt2, pt3, pt4 } = viewDocCoord;
  const minX = Math.min(pt1.x, pt2.x, pt3.x, pt4.x);
  const maxX = Math.max(pt1.x, pt2.x, pt3.x, pt4.x);

  // 计算视区的宽度和高度
  const width = maxX - minX;

  //设置比例尺(最大500)
  let maxNum = Math.min(Math.round(width / 1000), 350);
  let ruleWidth = Math.min(width / 1000, 350);
  //存入vuex
  store.commit("platBtns/setRuleWidth", ruleWidth);
  store.commit("platBtns/setMaxNum", maxNum);
};
//修改栅格显隐
const changeBackgroundGrid = (value) => {
  if (value.$event) {
    value = value.value;
  }
  window.gridShow.toggleVisibility(value);

  //解决初始就需要渲染，所以这里不能再次渲染
  // if (value) {
  // // 如果要显示栅格，绑定事件并更新栅格
  // rlAppObj._rlMx.MxFun.getCurrentDraw().addEvent(
  //   "viewchange",
  //   this.updateGridOnViewChange
  // );
  // this.updateGridOnViewChange(); // 确保在当前视图立即更新一次栅格
  // } else {
  //   // 如果隐藏栅格，从视图变化事件中移除更新栅格的回调
  //   rlAppObj._rlMx.MxFun.getCurrentDraw().off(
  //     "viewchange",
  //     this.updateGridOnViewChange
  //   );
  // }
  let storageData = getBtnStatus();
  if (storageData) {
    // 存储数据
    storageData.gridShow = value;
    localStorage.setItem("uSettings", JSON.stringify(storageData));
  }
};

// 切换比例尺
const toggleScale = (value) => {
  if (value.$event) {
    value = value.value;
  }
  if (value) {
    rlAppObj._rlMx.MxFun.getCurrentDraw().addEvent(
      "viewchange",
      updateScaleChange
    );
    // 比例尺监听
    updateScaleChange();
  } else {
    rlAppObj._rlMx.MxFun.getCurrentDraw().off("viewchange", updateScaleChange);
  }
  let storageData = getBtnStatus();
  if (storageData) {
    // 存储数据
    storageData.scaleShow = value;
    localStorage.setItem("uSettings", JSON.stringify(storageData));
  }

  store.commit("platBtns/setScaleShow", value);
};

// 切换背景颜色
const changeBackgroundColor = (isBlack) => {
  const value = isBlack.value == 200 ? 200 : 51;
  rlAppObj.mxcadObject.setViewBackgroundColor(value, value, value);
  let hexValue = (value << 16) | (value << 8) | value;
  rlThreeObj.Trenderer.setClearColor(hexValue, 1);

  store.commit("cadModules/set_bgc", value);
  window.rlAppObj.rlMxDrawObject.updateDisplay();
  let storageData = getBtnStatus();
  if (storageData) {
    // 存本地
    storageData.bgc = isBlack;
    localStorage.setItem("uSettings", JSON.stringify(storageData));
  }
  //草图模式下,更新网格标注的颜色
  if (store.state.globalData.isSketch) {
    const allGridC = store.state.rlEntData.totalEntityData["rlGridC"];
    for (let i = 0; i < allGridC.length; i++) {
      allGridC[i].drawText();
    }
  }
  rlAppObj.rlMxDrawObject.updateDisplay();
};

export { changeBackgroundGrid, toggleScale, changeBackgroundColor };
